export const BUILD_VERSION = '1779116743';
